/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Risk-Model-UI
 * Developer: Mike McGlone <mike@hbrisk.com>
 * Date: 12/17/20
 * Copyright All Rights Reserved
 */

const calculateOrgRequestBody = values => ({
  active: true,
  name: values.orgName,
  permissions: {
    modelTypes: [
      ...(values.standard ? [1] : []),
      ...(values.advanced ? [2] : []),
    ],
    perRealization: values.allRealizations || false,
  },
});

export default calculateOrgRequestBody;



// WEBPACK FOOTER //
// ./js/support/calculateOrgRequestBody.js